'use client';

import { ReactNode } from 'react';
import * as TabsSelector from '@/shared/ui/tabs-selector';
import { FormRadioGroup } from './form-radio-group';
import { FormFieldProps } from './types';

type RootProps = Omit<FormFieldProps<typeof FormRadioGroup>, 'children'> & {
    children?: ReactNode;
};

const FormTabsSelectorRootComponent = ({ children, ...props }: RootProps) => {
    return (
        <FormRadioGroup {...props} asChild>
            <TabsSelector.Wrapper>{children}</TabsSelector.Wrapper>
        </FormRadioGroup>
    );
};

type TabProps = Omit<FormFieldProps<typeof FormRadioGroup.Item>, 'children' | 'name'> & {
    children?: ReactNode;
};

const FormTabsSelectorTabComponent = ({ children, ...props }: TabProps) => {
    return (
        <FormRadioGroup.Item {...props} asChild>
            <TabsSelector.Tab>{children}</TabsSelector.Tab>
        </FormRadioGroup.Item>
    );
};

export const FormTabsSelector = Object.assign(FormTabsSelectorRootComponent, {
    Tab: FormTabsSelectorTabComponent,
});
